var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-success flex",on:{"mouseover":function($event){_vm.hovered = true},"mouseleave":function($event){_vm.hovered = false}}},_vm._l((5),function(i){return _c('span',{key:("start_" + i),class:[_vm.iconClass, !_vm.disabled ? 'is-clickable' : ''],on:{"click":function($event){return _vm.setVal(i)},"mouseover":function($event){return _vm.setHover(i)}}},[_c('b-icon',{attrs:{"icon":_vm.hovered
          ? i > _vm.hoveredValue && !_vm.disabled
            ? 'star-outline'
            : 'star'
          : i > _vm.innerValue
            ? 'star-outline'
            : 'star',"type":"is-success"}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }